<template>
  <div class="service" v-if='service'>
    <input type="file" id='photo' @change='loadPhoto' hidden ref="loadPhotoButton"/>
    <div :class="serviceObject.isMain? 'page-header-wrapper' : ''" v-bind:style="headerStyle" v-if="serviceObject.isMain">
      <div class="page-header translucent-wrapper">
        <div class="switch-wrapper">
          <b-switch v-model='serviceObject.isMain' @change="serviceChanged">Основная услуга</b-switch>
          <span class="switch-caption">Основные услуги отображаются блоком на главной</span>
        </div>
        <div class="centered">
          <span class="button-wrapper" @click="handleLoadServicePhoto"><a class="button is-info">+</a>Загрузить фото</span>
        </div>
        <b-field>
            <b-input placeholder="Заголовок" v-model="serviceObject.title" @change="handleUpdateService"></b-input>
        </b-field>
        <b-field>
          <b-input placeholder="Текст" type="textarea" v-model="serviceObject.description"  @change="handleUpdateService"></b-input>
        </b-field>
      </div>
    </div>
    <div v-else class="page-header secondary-service">
      <div class="switch-wrapper">
        <b-switch v-model='serviceObject.isMain' @change="serviceChanged">Основная улуга</b-switch>
      </div>
      <b-field>
          <b-input placeholder="Заголовок" v-model="serviceObject.title"></b-input>
      </b-field>
      <b-field>
        <b-input placeholder="Текст" type="textarea" v-model="serviceObject.description"></b-input>
      </b-field>
      <Editor
      :editorToolbar="customToolbar"
      placeholder="Текст информации"
      v-model="serviceObject.text"/>
    </div>
    <div v-if="serviceObject.isMain">
      <div class="service-description">
        <h2 class="has-text-centered">Описание</h2>
        <b-input placeholder="Текст" type="textarea" v-model="serviceObject.additionalInfo"  @change="handleUpdateService"></b-input>
      </div>
      <div class="caption">
        <h2>Преимущества услуги</h2>
        <span>Максимум 4 блока с преимуществами</span>
      </div>
      <div class="advantages">
        <draggable v-model="advantagesData">
          <Advantage v-for="advantage in serviceObject.advantages" :key="advantage.id" :advantage="advantage"/>
        </draggable>
        <div class="centered" v-if="serviceObject.advantages && serviceObject.advantages.length !== 4">
          <span class="button-wrapper" @click="handleAddAdvantage">
            <a class="button is-info">+</a>Добавить преимущество
          </span>
        </div>
      </div>
      <div class="caption">
        <h2>Экстра-преимущества услуги</h2>
        <span>Максимум 6 блоков с экстра-преимуществами</span>
      </div>
      <div class="extra-advantages logical-block-content">
        <div class="description-wrapper">
          <b-field>
            <b-input placeholder="Заголовок для экстра-преимуществ" v-model="serviceObject.extraAdvantagesTitle"
              class="p-option"></b-input>
          </b-field>
        </div>
        <ExtraAdvantage v-for="advantage in serviceObject.extraAdvantages" class="extra-advantage-item"
          :key="advantage.id" :advantage="advantage"
        />

        <div class="centered"
          v-if="serviceObject.extraAdvantages && serviceObject.extraAdvantages.length !== 6"
        >
          <span class="button-wrapper" @click="handleAddExtraAdvantage">
            <a class="button is-info">+</a>Добавить экстра-преимущество
          </span>
        </div>
      </div>
      <div class="calculator-option">
        <div class="switch-wrapper">
          <b-switch v-model="serviceObject.showCalculator">Показывать калькулятор</b-switch>
        </div>
      </div>
      <div class="caption">
        <h2>Принципы работы</h2>
      </div>
      <div class="principles">
        <draggable class="is-clearfix" v-model='principlesData'>
          <Principle v-for="principle in serviceObject.principles" :key="principle.id" :principle="principle"/>
        </draggable>
        <div class="centered">
          <span class="button-wrapper" @click="handleAddPrinciple"><a class="button is-info">+</a>Добавить новый принцип работы</span>
        </div>
      </div>
      <div class="caption">
        <h2>Акция, соответствующая услуге</h2>
        <span>Чтобы добавить акцию перейдите в меню "Акции"</span>
      </div>
      <div class="promo-wrapper is-flex">
        <el-select v-model="selectedPromo" placeholder="Выбрать акцию" @change="changePromo" class="promo-option" clearable>
          <el-option
            v-for="promo in servicePromos"
            :key="promo.id"
            :label="promo.title"
            :value="promo.id">
          </el-option>
        </el-select>
      </div>
      <div class="caption">
        <h2>Узнать подробнее</h2>
      </div>
      <div class="learn-more">
        <b-field class="learn-more-field">
          <b-input placeholder="Заголовок" v-model="serviceObject.learnMoreButton.title" required />
          <b-input placeholder="Ссылка" v-model="serviceObject.learnMoreButton.url" required />
        </b-field>
      </div>
      <div class="caption">
        <h2>Сопутствующая услуга</h2>
      </div>
      <div class="promo-wrapper is-flex">
        <el-select v-model="selectedService" placeholder="Выбрать услугу" @change="changeAdditionalService" class="promo-option" clearable>
          <el-option
            v-for="service in additionalServices"
            :key="service.id"
            :label="service.title"
            :value="service.id">
          </el-option>
        </el-select>
      </div>
      <div class="caption">
        <h2>Тарифы</h2>
      </div>
      <div class="rates-wrapper">
        <draggable v-model="ratesData" class="is-clearfix">
          <Rate v-for="rate in serviceObject.rates" :key="rate.id" :rate="rate"/>
        </draggable>
        <div class="centered">
          <span class="button-wrapper" @click="handleAddRate"><a class="button is-info">+</a>Добавить тариф</span>
        </div>
        <div class="centered">
          <span class="button-wrapper" v-if="!serviceObject.ratesComparisonFile" @click="handleloadDocument"><a class="button is-info">+</a>Загрузить документ сравнения тарифов</span>
          <span v-else class="rates-file">
             <a target="_blank" :href="'/' + serviceObject.ratesComparisonFile">Просмотреть документ сравнения тарифов</a>
             <img src="/static/img/icons/delete.svg" class="delete-icon" @click="deleteRatesComparisonFile"/>
           </span>
          <input type="file" @change='loadDocument' hidden ref="loadDocumentButton"/>
        </div>
        <div class="promo-wrapper is-flex">
          <el-select v-model="selectedRatesDocument" placeholder="Выбрать документ тарифов"
            @change="changeRatesDocument" class="p-option" clearable
          >
            <el-option
              v-for="document in newDocumentsData"
              :key="[document.path, document.resource_id].join('###')"
              :label="`${document.display_name}`"
              :value="[document.path, document.resource_id].join('###')">
            </el-option>
          </el-select>
        </div>
      </div>
      <div class="caption">
        <h2>Отзыв или успешная история</h2>
      </div>
      <div class="reviews">
        <div class="centered">
          <span class="button-wrapper" @click="handleAddReview"><a class="button is-info">+</a>Добавить отзыв</span>
        </div>
        <swiper :options="swiperOption" v-if="serviceObject.reviews && serviceObject.reviews.length">
          <swiper-slide  v-for="review in serviceObject.reviews" :key="review.id">
            <Review :review="review" />
          </swiper-slide>
          <div class="swiper-pagination" slot="pagination"></div>
          <div class="swiper-button-prev" slot="button-prev"></div>
          <div class="swiper-button-next" slot="button-next"></div>
        </swiper>
      </div>

      <div class="caption">
        <h2>Порядковый номер в списке</h2>
      </div>
      <div class="centered">
        <b-field>
          <b-input
            placeholder="Номер индекса"
            v-model="serviceObject.indexNumber"
            @change="handleUpdateService">
          </b-input>
        </b-field>
      </div>

      <div class="caption">
        <h2>Как стать клиентом</h2>
        <div class="columns">
          <BecomeClient
            v-for="becomeClientData in serviceObject.becomeClientData"
            :key="becomeClientData.id"
            :becomeClientData="becomeClientData"
          />
        </div>
        <div class="centered" v-if="serviceObject.becomeClientData && serviceObject.becomeClientData.length < 3">
          <span class="button-wrapper" @click="addBecomeClientData()"><a class="button is-info">+</a>Добавить блок</span>
        </div>
      </div>
    </div>
    <div class="save-content-button centered">
      <button class="button save-content" @click="handleSaveService()" :disabled="disabled">{{ disabled ? 'Идет сохранение...' : 'СОХРАНИТЬ' }}</button>
    </div>
    <div class="columns">
      <div class="column delete-service is-one-third" @click="deleteService">
        <span>Удалить</span>
      </div>
      <div class="column hide">
        <b-switch
        v-model='serviceObject.isHidden'
        @input="setServiceGroup()">
          Скрыть услугу с сайта
        </b-switch>
      </div>
    </div>
  </div>
</template>

<script>
  import { mapState, mapActions } from 'vuex'
  import Advantage from 'components/Services/Advantage'
  import ExtraAdvantage from 'components/Services/ExtraAdvantage'
  import Principle from 'components/Services/Principle'
  import Rate from 'components/Services/Rate'
  import Review from 'components/Services/Review'
  import BecomeClient from 'components/Services/BecomeClient'
  import deepcopy from 'deepcopy'
  import draggable from 'vuedraggable'
  import { VueEditor as Editor } from 'vue2-editor'
  import uuidv4 from 'uuid/v4'
  import router from '../../router'

  export default {
    name: 'Service',
    data () {
      return {
        autoplay: false,
        disabled: false,
        selectedPromo: null,
        selectedService: null,
        customToolbar: [
          ['bold', 'italic', 'underline'],
          [{'list': 'ordered'}, {'list': 'bullet'}],
          [{ 'header': [1, 2, 3, 4, 5, 6, false] }],
          ['link', 'image'],
          [{ 'align': [] }]
        ],
        swiperOption: {
          pagination: '.swiper-pagination',
          paginationClickable: true,
          nextButton: '.swiper-button-next',
          prevButton: '.swiper-button-prev',
          spaceBetween: 30,
          autoHeight: false
        },
        base64photo: '',
        selectedRatesDocument: null,
        indexNumber: null
      }
    },
    computed: {
      ...mapState(['service', 'servicePromos', 'services', 'documentTypes', 'newDocumentTypes']),
      serviceObject () {
        if (this.service) {
          if (!this.service.isNew && this.$route.params.id === 'new') {
            router.push({ name: 'Services' })
          }
          this.base64photo = ''
          return deepcopy(this.service)
        } else {
          return {}
        }
      },
      documentsData: {
        get () {
          const result = []
          deepcopy(this.documentTypes).forEach(x => result.push(...x.documents))
          return result
        }
      },
      newDocumentsData: {
        get () {
          const result = []
          deepcopy(this.newDocumentTypes).forEach(x => result.push(x))
          return result
        }
      },
      advantagesData: {
        get () {
          return deepcopy(this.service.advantages)
        },
        set (val) {
          this.updateOrder(val, 'advantages')
        }
      },
      principlesData: {
        get () {
          return deepcopy(this.service.principles)
        },
        set (val) {
          this.updateOrder(val, 'principles')
        }
      },
      ratesData: {
        get () {
          return deepcopy(this.service.rates)
        },
        set (val) {
          this.updateOrder(val, 'rates')
        }
      },
      headerStyle () {
        return (this.serviceObject.photo && this.serviceObject.isMain) || this.base64photo
        ? {background: !this.base64photo.length ? `url(/upload/photos/${this.service.photo})` : `url(${this.base64photo})`}
        : {background: ''}
      },
      additionalServices () {
        return this.services.filter(s => s.id !== this.service.id)
      }
    },
    created () {
      this.getPromosForServices()
      this.getNewDocumentsTypes()
    },
    methods: {
      ...mapActions(['deleteService',
        'saveService', 'addAdvantage', 'addExtraAdvantage', 'addPrinciple',
        'loadServicePhoto', 'addRate', 'deleteRate', 'getPromosForServices',
        'addReview', 'deleteReview', 'changeRatesComparisonFile', 'getDocumentsTypes', 'getNewDocumentsTypes',
        'deleteRatesComparisonFile', 'updateServiceItemsOrder', 'addBecomeClientData']),
      handleLoadServicePhoto () {
        this.$refs.loadPhotoButton.click()
      },
      updateOrder (val, field) {
        this.serviceObject[field] = val
        for (let i = 0; i < val.length; i++) {
          val[i].order = i
        }
        this.serviceObject[field] = val
        this.handleUpdateService()
      },
      changeRatesDocument (value) {
        this.serviceObject.ratesDocument_id = value
        if (value) {
          this.serviceObject.ratesDocument = this.newDocumentsData.find(d => this.serviceObject.ratesDocument_id.indexOf(d.resource_id) !== -1)
        }
      },
      handleSaveService () {
        this.disabled = true
        this.saveService(this.serviceObject)
        .then(() => {
          this.disabled = false
          this.$toast.open({ message: 'Сохранено' })
        })
      },
      handleAddAdvantage () {
        if (this.serviceObject.advantages.length < 4) {
          this.addAdvantage({
            order: this.serviceObject.advantages.length,
            title: '',
            description: '',
            service_id: this.serviceObject.id,
            id: uuidv4()
          })
          this.$forceUpdate()
        }
      },
      handleAddExtraAdvantage () {
        if (this.serviceObject.extraAdvantages.length < 6) {
          this.addExtraAdvantage({
            order: this.serviceObject.extraAdvantages.length,
            title: '',
            description: '',
            videoPreview: '',
            videoLink: '',
            buttonLink: '',
            buttonTitle: 'ПОДРОБНЕЕ',
            serviceId: this.serviceObject.id,
            id: uuidv4()
          })
          this.$forceUpdate()
        }
      },
      handleAddPrinciple () {
        this.addPrinciple({
          id: uuidv4(),
          title: '',
          description: '',
          service_id: this.serviceObject.id,
          order: this.serviceObject.principles.length
        })
      },
      handleAddRate () {
        this.addRate({
          id: uuidv4(),
          title: '',
          description: '',
          service_id: this.serviceObject.id,
          order: this.serviceObject.rates.length
        })
      },
      handleAddReview () {
        this.addReview({
          id: uuidv4(),
          title: '',
          description: '',
          result: '',
          photo: '',
          service_id: this.serviceObject.id
        })
      },
      handleUpdateService () {
        this.updateServiceItemsOrder(this.serviceObject)
      },
      changePromo (value) {
        this.serviceObject.promo_id = value
        this.serviceObject.promo = this.servicePromos.find(p => p.id === value)
      },
      serviceChanged () {
        this.$forceUpdate()
      },
      changeAdditionalService (value) {
        this.serviceObject.service_id = value || null
        this.serviceObject.concomitantService = this.services.find(s => s.id === value)
      },
      handleloadDocument () {
        this.$refs.loadDocumentButton.click()
      },
      loadDocument (e) {
        const formData = new FormData()
        const file = e.target.files[0]
        formData.set('document', file)
        this.serviceObject.newRatesComparisonFile = formData
        this.changeRatesComparisonFile(file.name)
        this.handleUpdateService()
      },
      loadPhoto (e) {
        const reader = new FileReader()
        reader.readAsDataURL(e.target.files[0])
        reader.onload = (e) => {
          this.base64photo = e.target.result
          this.$forceUpdate()
        }
        const formData = new FormData()
        const file = e.target.files[0]
        formData.set('avatar', file)
        this.serviceObject.newPhoto = formData
      },
      deleteRatesComparisonFile () {
        this.serviceObject.newRatesComparisonFile = null
        this.changeRatesComparisonFile('')
      },
      setServiceGroup () {
        this.serviceObject.groupNumber = this.serviceObject.groupNumber === 2
          ? 3
          : this.serviceObject.groupNumber
      }
    },
    watch: {
      service (val) {
        this.selectedPromo = val.promo ? val.promo.id : null
        this.selectedService = val.concomitantService ? val.concomitantService.id : null
        this.selectedRatesDocument = val.ratesDocument_id ? val.ratesDocument_id : null
      }
    },
    components: {Advantage, ExtraAdvantage, Principle, Rate, Review, BecomeClient, Editor, draggable}
  }
</script>

<style>
.service {
  width: calc(100% - 200px);
  display: flex;
  flex-direction: column;
}
.delete-service {
  background: red;
  text-align: center;
  color: white;
  cursor: pointer;
}
.hide {
  background: #a8c6fa;
  text-align: center;
}
.reviews {
  margin: 0 0 50px;
}
.review .textarea {
  min-height: 80px;
}
.promo-option {
  width: 100%;
  max-width: 640px;
  margin: 0 auto;
}
.delete-file {
  cursor: pointer;
  margin: 0 5px 0 0;
}
.rates-file {
  position: relative;
}
.rates-file .delete-icon {
  top: 0px;
  right: -35px;
}
.page-header-wrapper {
  background-size: cover !important;
  background-position: center !important;
}
.page-header {
  margin: 0 auto;
}
.services {
  display: flex;
  flex-direction: row;
}
.services .quillWrapper {
  margin: 0 0 45px;
}
.secondary-service {
  margin-top: 57px;
}
.secondary-service .switch-wrapper {
  margin: 0 0 20px;
}
.sub-menu ul {
  flex-direction: column;
  overflow: hidden;
  margin-right: 20px;
}
.service .learn-more-field {
  max-width: 600px;
  margin: 0 auto;
}
.service .learn-more-field .control {
  width: 100%;
}
.service .learn-more-field .control:first-child {
  margin-right: 10px;
}
.service .become-client .ql-editor {
  height: 125px;
}

.extra-advantages {
  margin-bottom: 20px;
}

.description-wrapper {
  padding: 30px 20px;
}

.extra-advantage-item {
  margin-bottom: 30px;
}
.extra-advantage-item:last-child {
  margin-bottom: 0;
}
</style>



// WEBPACK FOOTER //
// Service.vue?ecd97514